import React, { createContext, useContext, useState } from "react";
import T from "./translations";
import { T_EXTRA } from "./translations_extra";

const LangContext = createContext();

// Fusionar T con T_EXTRA - T_EXTRA tiene prioridad si hay duplicados
const T_MERGED = {};
const LANGS = ["es", "en", "fr", "de", "it"];
LANGS.forEach((lang) => {
  T_MERGED[lang] = {
    ...(T[lang] || {}),
    ...(T_EXTRA[lang] || {}),
  };
});

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("lang", l);
  };
  const t = (key) => (T_MERGED[lang] && T_MERGED[lang][key]) || T_MERGED.es[key] || key;
  return (
    <LangContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
